import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import FiltersSoonInCinema from "../../../SHARED/components/filters/filterssoonincinema.component";
import ResultsSoonInCinema from "./containers/resultssoonincinema.component";
import RecommendedForYou from "../recommendedforyou/recommendedforyou.component";
import Spinner from "../../../SHARED/components/spinner/spinner.component";
import moment from "moment";
import { capitalizeFirstLetter, pageViewEvent } from '../../../SHARED/helpers/general.helper'
import Ads from "../ads/ads.component";
import { Helmet } from 'react-helmet';

class SoonInCinema extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedMonth: ''
        }
    }

    componentWillMount(){
        window.scrollTo(0, 0);
    }

    componentDidMount(){
        pageViewEvent('În curând în cinema - Cinemap','/in-curand-in-cinema')
    }

    passMonth = (month) => {
        this.setState({
            selectedMonth: capitalizeFirstLetter(moment(month).locale('ro').format('MMMM'))
        })
    };

    render() {
        return (
            <div className="soon-in-cinema">
                <Helmet>
                    <title>În curând în cinema - Cinemap</title>
                    <meta name="description" content="Lista cu filmele ce vor aparea în curând în cinema. Premiere cinema. Data premieri filmelor în cinema."/>
                    <link rel="canonical" href={window.location.href}/>
                </Helmet>
                {   window.innerWidth > 1000 ? 
                    <Ads
                        id="div-gpt-ad-1662463178982-0"
                        slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463178982-0'); googletag.pubads().refresh();});"
                    /> : 
                    <Ads
                        id="div-gpt-ad-1662463706379-0"
                        slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463706379-0'); googletag.pubads().refresh();});"
                    />
                }
                { this.props.loading !== 0 ? <Spinner /> : '' }
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-2 order-2 order-sm-2 order-md-1 sidebar-filters">
                            <FiltersSoonInCinema passMonth={this.passMonth}/>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-10 order-1 order-sm-1 order-md-2">
                            <ResultsSoonInCinema selectedMonth={this.state.selectedMonth}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="section-headline">
                            ARTICOLE RECOMANDATE
                        </div>
                        <RecommendedForYou/>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.loading.pendingRequests,
});
export default connect(mapStateToProps, {})(SoonInCinema);



// WEBPACK FOOTER //
// ./src/FO/components/soonincinema/soonincinema.component.js